module.exports = __webpack_public_path__ + "img/Vector.396be90f.svg";